import React from 'react'
import '../Home/Home.css'
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/menu');  
  }
  return (
    <div className='Home'>
      <div className="HomeImage1">
        <img src="/images/home1.png"/>
      </div>
      <div className="HomeImage2">
        <img src="/images/home.png"/>
      </div>
      <div className="HomeContent">
        <h1>Enjoy the taste of the HIMALAYAS!</h1>
        <p>Embark on a flavorful adventure 
with our traditional Nepali dishes, 
expertly crafted to bring the 
authentic taste of Nepal right to 
your plate at Mustang Thakali & Bar!</p>
        <button class="Button" onClick={handleClick}>
          <span class="shadow"></span>
          <span class="edge"></span>
          <span class="front">View Menu</span>
        </button>
      </div>
      
    </div>
  )
}

export default Home